/**
 * Phoenix Tokens 🐦‍🔥 — tier helpers (mirror of backend TOKEN_TIERS).
 * Used for client-side display when needed without an API call.
 */
export const TOKEN_TIERS = [
  { key: "phoenix",     name: "Phoenix",     icon: "🐦‍🔥", value: 1000 },
  { key: "phoenix_egg", name: "Phoenix Egg", icon: "🔱",   value: 500 },
  { key: "inferno",     name: "Inferno",     icon: "💎",   value: 100 },
  { key: "blaze",       name: "Blaze",       icon: "🟠",   value: 25 },
  { key: "flame",       name: "Flame",       icon: "🔥",   value: 10 },
  { key: "ember",       name: "Ember",       icon: "🪙",   value: 5 },
  { key: "spark",       name: "Spark",       icon: "✨",   value: 1 },
];

export function tierBreakdown(total) {
  const out = [];
  let rem = Math.max(0, parseInt(total || 0, 10));
  for (const t of TOKEN_TIERS) {
    const c = Math.floor(rem / t.value);
    if (c > 0) {
      out.push({ ...t, count: c });
      rem -= c * t.value;
    }
  }
  return out;
}
